"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPlayer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactUse = require("react-use");
var _screenfull = _interopRequireDefault(require("screenfull"));
var _reactSdk = require("@100mslive/react-sdk");
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _PlaylistControls = require("./PlaylistControls");
var _constants = require("../../common/constants");
var _useUISettings = require("../AppData/useUISettings");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var VideoPlayer = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var peerId = _ref.peerId;
  var videoTrack = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectVideoPlaylistVideoTrackByPeerID)(peerId));
  var active = (0, _reactSdk.useHMSStore)(_reactSdk.selectVideoPlaylist.selectedItem);
  var isAudioOnly = (0, _useUISettings.useUISettings)(_constants.UI_SETTINGS.isAudioOnly);
  var hmsActions = (0, _reactSdk.useHMSActions)();
  var ref = (0, _react.useRef)(null);
  var _useToggle = (0, _reactUse.useToggle)(false),
    _useToggle2 = _slicedToArray(_useToggle, 2),
    show = _useToggle2[0],
    toggle = _useToggle2[1];
  var isFullscreen = (0, _reactUse.useFullscreen)(ref, show, {
    onClose: function onClose() {
      return toggle(false);
    }
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    direction: "column",
    justify: "center",
    css: {
      w: "100%",
      h: "100%"
    },
    ref: ref,
    children: [active && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      justify: "between",
      align: "center",
      css: {
        bg: "$menuBg",
        p: "$2 $2 $2 $6",
        borderTopLeftRadius: "$1",
        borderTopRightRadius: "$1"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        css: {
          color: "$textPrimary"
        },
        children: active.name
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.IconButton, {
        css: {
          color: "$white"
        },
        onClick: function onClick() {
          hmsActions.videoPlaylist.stop();
        },
        "data-testid": "videoplaylist_cross_btn",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.CrossIcon, {})
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Video, {
      trackId: videoTrack === null || videoTrack === void 0 ? void 0 : videoTrack.id,
      attach: !isAudioOnly,
      css: {
        "@lg": {
          objectFit: "contain",
          h: "auto"
        },
        r: "$1",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PlaylistControls.VideoPlaylistControls, {
      children: _screenfull["default"].enabled && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.IconButton, {
        onClick: function onClick() {
          return toggle();
        },
        css: {
          color: "$white",
          height: "max-content",
          alignSelf: "center",
          cursor: "pointer"
        },
        children: isFullscreen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ShrinkIcon, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ExpandIcon, {})
      })
    })]
  });
});
exports.VideoPlayer = VideoPlayer;